module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_4-73d2824c5476bf96075cf51742ebfe42.png";